import {
	TreatmentConfigOptions,
	TreatmentConfigTemplate,
} from "../../../domain/treatmentPlan.interface";
import { AgentConfigDraft, draftToTemplate } from "./draftToTemplate";
import { mergeDraftOptions } from "./draftToOptions";

export interface DraftApplication {
	/** The plan's option lists with the assistant's proposals folded in. */
	options: TreatmentConfigOptions;
	/** What the merge would add to the plan, in words. */
	additions: string[];
	/** Null while the config is still incomplete; `blockers` says why. */
	template: TreatmentConfigTemplate | null;
	blockers: string[];
}

/**
 * Turn a draft into everything it would change on the plan.
 *
 * Options are merged first, and the template is then resolved against the
 * merged list — that ordering is the whole point: a schedule the assistant
 * proposed this turn has to exist before the template can reference it, which
 * is what let the assistant work on a plan that started empty.
 */
export const applyDraft = (
	draft: AgentConfigDraft | null,
	planOptions: TreatmentConfigOptions | undefined,
): DraftApplication => {
	const { options, additions } = mergeDraftOptions(draft?.options, planOptions);
	const existingTemplates = options.treatmentConfigTemplates ?? [];
	const { template, blockers } = draftToTemplate(draft, options, {
		isFirstTemplate: existingTemplates.length === 0,
	});

	return { options, additions, template, blockers };
};
